import React from "react";
import { formatKennitala, validatePhoneNumber, validateEmail } from "../../utils";
import { SvgPenIcon, SvgCheckIcon, SvgEyeIcon, SvgRefreshIcon } from '../svg'
import { updateCompanyDetails } from '../../api/company-details/actions'

class DetailedCompanyInfo extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            editing: false,
            errors: {
                contactName: '',
                phone: '',
                //cellularPhone: '',
                email: '',
                createClaims: '',
            }
        }
        this.toggleEditField = this.toggleEditField.bind(this)
        this.onChangeTextInput = this.onChangeTextInput.bind(this)
        this.saveData = this.saveData.bind(this)
        this.validateForm = this.validateForm.bind(this)

        this.containerRef = React.createRef();
        this.contactName = React.createRef();
        this.phone = React.createRef();
        // this.cellularPhone = React.createRef();
        this.email = React.createRef();
        this.createClaims = React.createRef();
        this._handleKeyDown = this._handleKeyDown.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (
            (!prevProps.companyDetails && this.props.companyDetails) ||
            (JSON.stringify(prevProps.companyDetails.data) !== JSON.stringify(this.props.companyDetails.data))
        ) {
            let customer = this.props.companyDetails.data.Customer;
            this.setState({
                email: customer.ContactEmail,
                phone: customer.ContactPhone,
                contactName: customer.ContactName,
                createClaims: customer.CreateDeclarationClaim === 1,
                // cellularPhone: customer.CellularPhone
            })
        }
    }

    componentDidMount() {
        if (this.containerRef && this.containerRef.current) {
            this.containerRef.current.addEventListener('keydown', this._handleKeyDown);
        }
    }

    componentWillUnmount() {
        if (this.containerRef && this.containerRef.current) {
            this.containerRef.current.removeEventListener('keydown', this._handleKeyDown);
        }
    }

    _handleKeyDown(e) {
        const key = e.key || e.keyCode;
        const isEscape = key === 'Escape' || key === 'Esc' || key === 27;
        if (!isEscape) return;

        // Only act when the active element is an input/textarea/contenteditable inside this component
        const active = document.activeElement;
        if (!active) return;
        if (this.containerRef && this.containerRef.current && this.containerRef.current.contains(active)) {
            const tag = active.tagName && active.tagName.toUpperCase();
            const isEditable = tag === 'INPUT' || tag === 'TEXTAREA' || active.isContentEditable;
            if (isEditable && this.state && this.state.editing) {
                e.preventDefault();
                let errors = this.state.errors;
                for (const key of Object.keys(this.state.errors)) {
                    errors[key] = '';
                }
                this.setState({ errors: errors });
                this.toggleEditField();                
            }
        }
    }

    toggleEditField(e) {
        e && e.preventDefault();
        let editState = this.state.editing;
        this.setState({ editing: !editState });
    }

    onChangeTextInput(event) {
        this.setState({ [event.target.name]: event.target.value })
    }

    saveData() {
        if (this.validateForm()) {
            // let customerId = this.props.customers.customerList[0].Customer.AccountNum
            Promise.resolve(this.props.dispatch(updateCompanyDetails(this.props.company.company_id, {
                contact_phone: this.state.phone ? this.state.phone.trim().replace(' ','').replace('-','') : '',
                // cellular_phone: this.state.cellularPhone.trim().replace(' ','').replace('-',''),
                contact_name: this.state.contactName ? this.state.contactName.trim() : '',
                contact_email: this.state.email ? this.state.email.trim() : '',
                create_claims: this.state.createClaims
            }))).then(() => {
                this.toggleEditField();
            })
        }
    }

    validateForm() {
        let errors = this.state.errors;
        let valid = true;
        for (const key of Object.keys(this.state.errors)) {
            let validateFunction = (value) => true;
            let errorString = "";
            let value = this[key].current.value;
            if (value && (key === 'phone')) {
                validateFunction = validatePhoneNumber;
                errorString = 'Símanúmer er ekki gilt';
                value = value.trim().replace(' ','').replace('-','');
            } else if (value && (key === 'email')) {
                validateFunction = validateEmail;
                value = value.trim();
                errorString = 'Netfang er ekki gilt'
            }
            valid = valid && validateFunction(value);
            errors[key] = valid ? '' : errorString;
        }
        this.setState({ errors: errors })
        return valid;
    }

    render() {
        return (
            <>
                <div className="edit-company" ref={this.containerRef}>
                    <div className="form-row">
                        <div className="col-sm-4"><label htmlFor="" className="">Nafn</label></div>
                        <div className="col-sm-8 text-left">
                            {this.props.company.name}
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-sm-4"><label htmlFor="" className="">Kennitala</label></div>
                        <div className="col-sm-8 text-left">
                            {formatKennitala(this.props.company.company_id)}
                        </div>
                    </div>
                    <div className={`form-row`}>
                        <div className="col-sm-4">
                            <label htmlFor="" className="">
                                Nafn tengiliðs
                            </label>
                        </div>
                        <div className="col-sm-8 text-left">
                            {this.state.editing ?
                                <>
                                    <input ref={this.contactName} id="contactName" type="tel" pattern="[0-9]" className="form-control" name="contactName" onChange={this.onChangeTextInput} placeholder="" value={this.state.contactName} />
                                </>
                                :
                                <span>{(!this.state.contactName || this.state.contactName.trim() === '') ? ' ' : this.state.contactName}</span>
                            }
                        </div>
                    </div>                    
                    <div className={`${this.state.errors.phone.length > 0 ? 'error' : ''} form-row`}>
                        <div className="col-sm-4">
                            <label htmlFor="" className="">
                                Aðalsími
                                {this.state.errors.phone.length > 0 ?
                                    <span className="error"> ({this.state.errors.phone}) </span> : ''
                                }
                            </label>
                        </div>
                        <div className="col-sm-8 text-left">
                            {this.state.editing ?
                                <>
                                    <input ref={this.phone} id="phone" type="tel" pattern="[0-9]" className="form-control" name="phone" onChange={this.onChangeTextInput} placeholder="Sláðu inn símanúmer" value={this.state.phone} />
                                </>
                                :
                                <span>{(!this.state.phone || this.state.phone.trim() === '') ? '< ekkert númer skráð >' : this.state.phone}</span>
                            }
                        </div>
                    </div>
                    {/* <div className={`${this.state.errors.cellularPhone.length > 0 ? 'error' : ''} form-row`}>
                        <div className="col-sm-4">
                            <label htmlFor="" className="">
                                Farsími
                                {this.state.errors.cellularPhone.length > 0 ?
                                    <span className="error"> ({this.state.errors.cellularPhone}) </span> : ''
                                }
                            </label>
                        </div>
                        <div className="col-sm-8 text-left">
                            {this.state.editing ?
                                <>
                                    <input ref={this.cellularPhone} id="cellularPhone" type="tel" pattern="[0-9]" className="form-control" name="cellularPhone" onChange={this.onChangeTextInput} placeholder="Sláðu inn símanúmer" value={this.state.cellularPhone} />
                                </>
                                :
                                <span>{(!this.state.cellularPhone || this.state.cellularPhone.trim() === '') ? '< ekkert númer skráð >' : this.state.cellularPhone}</span>
                            }
                        </div>
                    </div> */}
                    <div className={`${this.state.errors.email.length > 0 ? 'error' : ''} form-row`}>
                        <div className="col-sm-4">
                            <label htmlFor="" className="">
                                Netfang launadeildar
                                {this.state.errors.email.length > 0 ?
                                    <span className="error"> ({this.state.errors.email}) </span> : ''
                                }
                            </label>
                        </div>
                        <div className="col-sm-8 text-left">
                            {this.state.editing ?
                                <>
                                    <input ref={this.email} id="email" type="email" className="form-control" name="email" onChange={this.onChangeTextInput} placeholder="Sláðu inn netfang" value={this.state.email} />
                                </>
                                :
                                <span>{(!this.state.email || this.state.email.trim() === '') ? '< ekkert netfang skráð >' : this.state.email}</span>
                            }
                        </div>
                    </div>
                    <div className={`form-row`}>
                        <div className="col-sm-4">
                            <label htmlFor="" className="">
                                Stofna kröfur í heimabanka
                            </label>
                        </div>
                        {this.state.editing
                            ?
                            <div className="col-sm-8">
                                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                    <input
                                        type="radio"
                                        ref={this.createClaims}
                                        name="createClaims"
                                        value="1"
                                        checked={this.state.createClaims === true || this.state.createClaims === '1'}
                                        onChange={() => this.setState({ createClaims: true })}
                                    />{' '}
                                    <label style={{ marginLeft: '0.75rem', marginRight: '0.75rem' }}>
                                        Já
                                    </label>
                                    <input
                                        type="radio"
                                        ref={this.createClaims}
                                        value="0"
                                        checked={this.state.createClaims === false || this.state.createClaims === '0'}
                                        onChange={() => this.setState({ createClaims: false })}
                                    />{' '}
                                    <label style={{ marginLeft: '0.75rem', marginRight: '0.75rem' }}>
                                        Nei
                                    </label>
                                </div>
                            </div>
                            :
                            <span>{this.state.createClaims ? "Já" : "Nei"}</span>
                        }

                    </div>
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
                    <button
                        className={`btn ${this.state.editing ? "btn-primary" : "btn-outline-primary"}`}
                        onClick={(e) => { !this.state.editing ? this.toggleEditField(e) : this.saveData() }}
                    >
                        {this.state.editing ? "Staðfesta" : "Breyta"}
                    </button>
                </div>

            </>
        )
    }
}

export default DetailedCompanyInfo